import { ActorRefFrom, setup } from 'xstate';
import { assignEstimatedSpend } from './assigns';
import { getAssignEstimatedSpendParams } from './actions';
import { EstimatedSpendMachineEvents } from './types/events';

export type EstimatedSpend = {
  INSTALLMENTS: number | undefined;
  SPLITPAY: number | undefined;
};

export interface EstimatedSpendContext {
  estimatedSpend: EstimatedSpend;
}

export type EstimatedSpendMachineActorRef = ActorRefFrom<
  typeof estimatedSpendMachine
>;

export const estimatedSpendMachine = setup({
  types: {
    context: {} as EstimatedSpendContext,
    events: {} as EstimatedSpendMachineEvents,
    input: {} as EstimatedSpendContext | undefined,
  },
  actions: {
    assignEstimatedSpend,
  },
}).createMachine({
  id: 'estimatedSpendMachine',
  context: ({ input }) => {
    return {
      estimatedSpend: {
        INSTALLMENTS: input?.estimatedSpend.INSTALLMENTS,
        SPLITPAY: input?.estimatedSpend.SPLITPAY,
      },
    };
  },
  initial: 'initialized',
  states: {
    initialized: {
      on: {
        SEND_UPDATE_ESTIMATED_SPEND: {
          actions: {
            type: 'assignEstimatedSpend',
            params: getAssignEstimatedSpendParams,
          },
        },
      },
    },
  },
});
